import { View } from "./View";

interface ISettingsNavLinks{
  navtitle: string;
  navtitlelink: string;
  
 
}

export const SettingsNavLinks = (
  props: ISettingsNavLinks
) => {
  return <View {...props}  />;
};
